import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './styles/hero.css';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const backgrounds = [
    'url("./images/bg1.jpg")',
    'url("./images/bg3.jpg")',
    'url("./images/bg4.jpg")'
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % backgrounds.length);
    }, 4000); // Change slide every 4 seconds

    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % backgrounds.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + backgrounds.length) % backgrounds.length);
  };

  return (
    <div 
      className="hero"
      style={{
        background: `linear-gradient(rgba(255,255,255,0.1), rgba(255,255,255,0.1)), ${backgrounds[currentSlide]} center/cover`
      }}
    >
      <button 
        onClick={prevSlide}
        className="hero__slider-button hero__slider-button--left"
        aria-label="Previous slide"
      >
        <ChevronLeft size={24} />
      </button>

      <button 
        onClick={nextSlide}
        className="hero__slider-button hero__slider-button--right"
        aria-label="Next slide"
      >
        <ChevronRight size={24} />
      </button>

      <div className="hero__content">
        <div className="hero__card">
          <h1>Innovative Medical Solution</h1>
          <p>Providing cutting-edge medical equipment and machines to elevate healthcare standards in Nepal.</p>
          <Link to="/contact" className="hero__button">Contact Us</Link>
        </div>
        <div className="hero__indicators">
          {backgrounds.map((_, index) => (
            <span 
              key={index} 
              className={currentSlide === index ? 'active' : ''}
              onClick={() => setCurrentSlide(index)}
            ></span>
          ))}
        </div>
      </div>
      <nav className="hero__nav">
        <span>Best Products</span>
        <span>Top Quality</span>
        <span>Many Brands</span>
      </nav>
    </div>
  );
};

export default HeroSection;